import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit"
import * as Sentry from "@sentry/react"
import { profileApi } from "../../features/profile/profileApi"
import { profileSlice } from "../../features/profile/profileSlice"
import { wsSlice } from "../slices/wsSlice"
import { appApi } from "./appApi"
import { setGlobalStore } from "./globalStore"

const sentryReduxEnhancer = Sentry.createReduxEnhancer({})

export const store = configureStore({
  reducer: {
    [profileApi.reducerPath]: profileApi.reducer,
    [appApi.reducerPath]: appApi.reducer,
    profile: profileSlice.reducer,
    ws: wsSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(profileApi.middleware, appApi.middleware),
  enhancers: (getDefaultEnhancers) => {
    return getDefaultEnhancers().concat(sentryReduxEnhancer)
  },
})

// Set the store reference for APIs
setGlobalStore(store)

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
